import { ListSermonsWebEndpoint } from '@nucleus/web-hosting';
import { useUser } from '@nucleus/web-theme';
import { InfiniteData, UseSuspenseInfiniteQueryResult, useSuspenseInfiniteQuery } from '@tanstack/react-query';
import { querySermons } from '../queries/sermon';

type QueryResult = Awaited<ReturnType<typeof querySermons>>;

export const useSermons = (
  engineId?: string,
  params?: ListSermonsWebEndpoint['queryStringParameters']
): UseSuspenseInfiniteQueryResult<InfiniteData<QueryResult>> => {
  const { currentUser, jwtToken } = useUser();

  return useSuspenseInfiniteQuery({
    queryKey: ['sermonHub', 'sermon', params, currentUser?.id],
    queryFn: ({ pageParam }) => querySermons(engineId, jwtToken, { ...params, cursor: pageParam }),
    initialPageParam: undefined as string | undefined,
    getNextPageParam: (lastPage) => lastPage.cursor,
  });
};
